(() => {
  // Display-only cleanup for retained Shopify content. Never rewrite form values,
  // URLs, credentials, code, or the underlying plan/product database records.
  const normaliseAbbPlanText = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => node.parentElement?.closest('form, input, select, option, textarea, script, style, noscript, code, pre, [contenteditable]')
        ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    let node;
    while ((node = walker.nextNode())) {
      const normalizedText = node.nodeValue.replace(/\bABB\s+Direct\s+(?!NBN\b)((?:(?:residential|business|fixed\s+wireless)\s+)?)plan(s?)\b/gi,
        (match, category, plural) => `ABB Direct NBN ${category}${plural ? 'Plans' : 'plan'}`);
      if (normalizedText !== node.nodeValue) node.nodeValue = normalizedText;
    }
  };
  normaliseAbbPlanText(document.querySelector('#MainContent') || document.querySelector('main.site-main'));
  document.addEventListener('shopify:section:load', (event) => normaliseAbbPlanText(event.target));

  // In-page service directories are navigation labels, not plan data. Keep the
  // same Title Case standard here without changing product names, prose, form
  // controls, destinations, prices, or any attributes.
  const normaliseServiceMenuText = (root) => {
    if (!root) return;
    const brandedWords = {
      abb: 'ABB', nbn: 'NBN', cis: 'CIS', esim: 'eSIM', voip: 'VoIP',
      opticomm: 'OptiComm', neoloop: 'Neoloop', eero: 'eero', netcomm: 'NetComm',
      ipoe: 'IPoE', pppoe: 'PPPoE', ipv4: 'IPv4', ipv6: 'IPv6', ip: 'IP',
      sim: 'SIM', pbx: 'PBX', uc: 'UC', payg: 'PAYG', wan: 'WAN', lan: 'LAN',
      usb: 'USB', hfc: 'HFC', fttp: 'FTTP', fttn: 'FTTN', fttc: 'FTTC', fttb: 'FTTB',
      adsl: 'ADSL', vdsl: 'VDSL', lte: 'LTE', '5g': '5G', '4g': '4G', '3g': '3G', '6e': '6E',
      nf20mesh: 'NF20MESH', nl20mesh: 'NL20MESH', nf71: 'NF71',
      'wi-fi': 'Wi-Fi', 'add-ons': 'Add-Ons', fairplay: 'FairPlay', connectyou: 'ConnectYou'
    };
    root.querySelectorAll('.plan-family-directory a').forEach((link) => {
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => node.parentElement?.closest('form, input, select, option, textarea, script, style, noscript, code, pre, [contenteditable], [aria-hidden="true"]')
          ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      let node;
      while ((node = walker.nextNode())) {
        const titleCaseText = node.nodeValue.replace(/[A-Za-z0-9]+(?:[-’'][A-Za-z0-9]+)*/g, (word) => {
          const key = word.toLowerCase();
          return brandedWords[key] || key.charAt(0).toUpperCase() + key.slice(1);
        });
        if (titleCaseText !== node.nodeValue) node.nodeValue = titleCaseText;
      }
    });
  };
  normaliseServiceMenuText(document);
  document.addEventListener('shopify:section:load', (event) => normaliseServiceMenuText(event.target));

  const body = document.body;
  const menu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const toast = document.querySelector('[data-toast]');
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const normalisePath = (path) => {
    const rawPath = String(path || '/');
    let decoded = rawPath;
    try {
      decoded = decodeURIComponent(rawPath);
    } catch (error) {
      // Use the browser-provided path unchanged if decoding is not possible.
    }
    decoded = decoded.replace(/\/+$/, '');
    return decoded || '/';
  };

  const currentPath = normalisePath(window.location.pathname);
  const currentView = new URL(window.location.href).searchParams.get('view') || '';
  document.querySelectorAll('.desktop-nav a[href], .mobile-menu nav a[href], .footer-links a[href]').forEach((link) => {
    try {
      const target = new URL(link.href, window.location.href);
      if (target.origin !== window.location.origin || normalisePath(target.pathname) !== currentPath || (target.searchParams.get('view') || '') !== currentView) return;
      link.setAttribute('aria-current', 'page');
      link.closest('.nav-details')?.classList.add('is-current');
      link.closest('.mobile-menu details')?.classList.add('is-current');
    } catch (error) {
      // Leave malformed or non-navigation URLs untouched.
    }
  });

  const setOpen = (panel, trigger, open) => {
    if (!panel || !trigger) return;
    const wasOpen = !panel.hidden;
    if (wasOpen === open) return;
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    if (panel === menu) body.classList.toggle('is-locked', open);
    if (open) {
      window.setTimeout(() => {
        const preferredTarget = panel === menu
          ? panel.querySelector('[data-menu-close]')
          : panel.querySelector('input[type="search"]');
        const firstFocusable = [...panel.querySelectorAll(focusableSelector)]
          .find((element) => element.getClientRects().length > 0);
        (preferredTarget || firstFocusable)?.focus();
      }, 20);
    } else {
      trigger.focus();
    }
  };

  menuToggle?.addEventListener('click', () => setOpen(menu, menuToggle, menu.hidden));
  document.querySelectorAll('[data-menu-close]').forEach((button) => {
    button.addEventListener('click', () => setOpen(menu, menuToggle, false));
  });

  searchToggle?.addEventListener('click', () => {
    const willOpen = searchPanel?.hidden ?? false;
    setOpen(searchPanel, searchToggle, willOpen);
  });
  document.querySelector('[data-search-close]')?.addEventListener('click', () => setOpen(searchPanel, searchToggle, false));

  menu?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || menu.hidden) return;
    const focusable = [...menu.querySelectorAll(focusableSelector)]
      .filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setOpen(menu, menuToggle, false);
    setOpen(searchPanel, searchToggle, false);
    document.querySelectorAll('.nav-details[open]').forEach((details) => details.removeAttribute('open'));
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nav-details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.querySelectorAll('.nav-details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.nav-details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    });
  });

  document.querySelectorAll('[data-auto-submit]').forEach((control) => {
    control.addEventListener('change', () => control.form?.requestSubmit());
  });

  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const control = button.closest('.quantity-control');
      const input = control?.querySelector('[data-quantity-input]');
      if (!input) return;
      const current = Number(input.value) || 1;
      input.value = String(Math.max(Number(input.min) || 1, current + (button.matches('[data-quantity-plus]') ? 1 : -1)));
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const price = select.selectedOptions[0]?.dataset.price;
      const wrapper = select.closest('[data-product-section]');
      const priceElement = wrapper?.querySelector('[data-product-price] strong');
      if (price && priceElement) priceElement.textContent = price;
    });
  });

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const previousText = submit?.textContent;
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding…';
      }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add this item.');
        const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        showToast('Added to your cart.');
      } catch (error) {
        showToast(error.message || 'Something went wrong. Please try again.');
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = previousText;
        }
      }
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-plan-finder-jump]');
    if (!trigger) return;
    const finder = document.querySelector('[data-service-selector]');
    if (!finder) return;
    event.preventDefault();
    finder.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  });

  const serviceSelectorInstances = new WeakMap();

  const getServiceSelectors = (scope = document) => [
    ...(scope.matches?.('[data-service-selector]') ? [scope] : []),
    ...(scope.querySelectorAll?.('[data-service-selector]') || [])
  ];

  const initialiseServiceSelectors = (scope = document) => {
    const selectors = getServiceSelectors(scope);

    selectors.forEach((selector) => {
      if (serviceSelectorInstances.has(selector) || selector.dataset.selectorReady === 'true') return;
      selector.dataset.selectorReady = 'true';

      const familyButtons = [...selector.querySelectorAll('[data-selector-family]')];
      const categoryGroups = [...selector.querySelectorAll('[data-category-group]')];
      const planPanels = [...selector.querySelectorAll('[data-plan-panel]')];
      const status = selector.querySelector('[data-selector-status]');
      const categoryHeading = selector.querySelector('[data-category-heading]');
      const rememberedCategories = new Map();
      const carouselInstances = new Map();
      const cleanupCallbacks = [];

      const addListener = (target, type, listener, options) => {
        if (!target) return;
        target.addEventListener(type, listener, options);
        cleanupCallbacks.push(() => target.removeEventListener(type, listener, options));
      };

      const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

      const initialiseCarousel = (carousel) => {
        const track = carousel.querySelector('[data-carousel-track]');
        if (!track || carouselInstances.has(carousel)) return;

        const previousButton = carousel.querySelector('[data-carousel-prev]');
        const nextButton = carousel.querySelector('[data-carousel-next]');
        const position = carousel.querySelector('[data-carousel-position]');
        const progress = carousel.querySelector('[data-carousel-progress]');
        let updateFrame;
        let resizeObserver;
        let dragPointerId;
        let dragStartX = 0;
        let dragStartScroll = 0;
        let isPointerDragging = false;
        let suppressDraggedClick = false;
        let suppressClickTimer;

        const getCards = () => {
          const labelledCards = [...track.querySelectorAll('[data-carousel-card]')];
          const candidates = labelledCards.length ? labelledCards : [...track.children];
          return candidates.filter((card) => card instanceof Element && !card.hidden);
        };

        const isVisible = () => !carousel.closest('[hidden]') && track.clientWidth > 0;

        const setScrollPosition = (left, smooth = true) => {
          const options = {
            left: Math.max(0, left),
            behavior: smooth && !prefersReducedMotion() ? 'smooth' : 'auto'
          };
          if (typeof track.scrollTo === 'function') {
            track.scrollTo(options);
          } else {
            track.scrollLeft = options.left;
          }
        };

        const getCardStart = (card) => {
          const trackRect = track.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          return track.scrollLeft + cardRect.left - trackRect.left;
        };

        const getVisibleRange = (cards) => {
          const trackRect = track.getBoundingClientRect();
          const visibleIndexes = [];

          cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const intersection = Math.min(cardRect.right, trackRect.right) - Math.max(cardRect.left, trackRect.left);
            if (intersection > 1) visibleIndexes.push(index);
          });

          if (visibleIndexes.length) {
            return {
              first: visibleIndexes[0],
              last: visibleIndexes[visibleIndexes.length - 1]
            };
          }

          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          cards.forEach((card, index) => {
            const distance = Math.abs(getCardStart(card) - track.scrollLeft);
            if (distance < closestDistance) {
              closestIndex = index;
              closestDistance = distance;
            }
          });
          return { first: closestIndex, last: closestIndex };
        };

        const update = () => {
          updateFrame = undefined;
          if (!isVisible()) return;

          const cards = getCards();
          const total = cards.length;
          const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const currentScroll = Math.min(maximumScroll, Math.max(0, track.scrollLeft));
          const atStart = currentScroll <= 1;
          const atEnd = maximumScroll <= 1 || currentScroll >= maximumScroll - 1;

          if (previousButton) {
            previousButton.disabled = !total || atStart;
            previousButton.setAttribute('aria-disabled', String(!total || atStart));
          }
          if (nextButton) {
            nextButton.disabled = !total || atEnd;
            nextButton.setAttribute('aria-disabled', String(!total || atEnd));
          }

          if (!total) {
            if (position && position.textContent !== 'Plans 0 of 0') position.textContent = 'Plans 0 of 0';
            if (progress) {
              progress.style.setProperty('--carousel-progress-size', '0%');
              progress.style.setProperty('--carousel-progress-offset', '0%');
              progress.style.width = '0%';
              progress.style.transform = 'translateX(0%)';
            }
            return;
          }

          const range = getVisibleRange(cards);
          if (position) {
            const rangeEnd = range.last === range.first ? '' : `\u2013${range.last + 1}`;
            const rangeText = `Plans ${range.first + 1}${rangeEnd} of ${total}`;
            if (position.textContent !== rangeText) position.textContent = rangeText;
          }

          if (progress) {
            const sizePercent = maximumScroll <= 1
              ? 100
              : Math.min(100, Math.max(4, (track.clientWidth / track.scrollWidth) * 100));
            const offsetPercent = maximumScroll <= 1
              ? 0
              : (currentScroll / maximumScroll) * (100 - sizePercent);
            const translatePercent = sizePercent ? (offsetPercent / sizePercent) * 100 : 0;
            progress.style.setProperty('--carousel-progress-size', `${sizePercent}%`);
            progress.style.setProperty('--carousel-progress-offset', `${offsetPercent}%`);
            progress.style.width = `${sizePercent}%`;
            progress.style.transform = `translateX(${translatePercent}%)`;
          }
        };

        const queueUpdate = () => {
          if (updateFrame !== undefined) return;
          updateFrame = window.requestAnimationFrame(update);
        };

        const findCurrentCardIndex = (cards) => {
          let currentIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          cards.forEach((card, index) => {
            const distance = Math.abs(getCardStart(card) - track.scrollLeft);
            if (distance < closestDistance) {
              currentIndex = index;
              closestDistance = distance;
            }
          });
          return currentIndex;
        };

        const moveByOneCard = (direction) => {
          if (!isVisible()) return;
          const cards = getCards();
          if (!cards.length) return;
          const currentIndex = findCurrentCardIndex(cards);
          const targetIndex = Math.min(cards.length - 1, Math.max(0, currentIndex + direction));
          setScrollPosition(getCardStart(cards[targetIndex]));
          queueUpdate();
        };

        const handleTrackKeydown = (event) => {
          if (event.target !== track || !isVisible()) return;
          const cards = getCards();
          if (!cards.length) return;

          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            moveByOneCard(event.key === 'ArrowRight' ? 1 : -1);
            return;
          }
          if (event.key === 'Home') {
            event.preventDefault();
            setScrollPosition(0);
            queueUpdate();
          }
          if (event.key === 'End') {
            event.preventDefault();
            setScrollPosition(Math.max(0, track.scrollWidth - track.clientWidth));
            queueUpdate();
          }
        };

        const clearDragState = () => {
          track.classList.remove('is-dragging');
          track.removeAttribute('data-dragging');
          isPointerDragging = false;
          dragPointerId = undefined;
        };

        const snapToNearestCard = () => {
          if (!isVisible()) return;
          const cards = getCards();
          if (!cards.length) return;
          const nearestIndex = findCurrentCardIndex(cards);
          setScrollPosition(getCardStart(cards[nearestIndex]));
          queueUpdate();
        };

        const handlePointerDown = (event) => {
          if (event.pointerType !== 'mouse' || !event.isPrimary || event.button !== 0 || !isVisible()) return;
          dragPointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartScroll = track.scrollLeft;
          isPointerDragging = false;
        };

        const handlePointerMove = (event) => {
          if (event.pointerId !== dragPointerId || event.pointerType !== 'mouse') return;
          const distance = event.clientX - dragStartX;
          if (!isPointerDragging) {
            if (Math.abs(distance) < 6 || !(event.buttons & 1)) return;
            isPointerDragging = true;
            track.classList.add('is-dragging');
            track.setAttribute('data-dragging', 'true');
            try {
              track.setPointerCapture?.(event.pointerId);
            } catch (error) {
              // Pointer capture can fail if the pointer ended between move events.
            }
          }

          event.preventDefault();
          const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          track.scrollLeft = Math.min(maximumScroll, Math.max(0, dragStartScroll - distance));
          queueUpdate();
        };

        const finishPointerDrag = (event) => {
          if (event.pointerId !== dragPointerId) return;
          const completedDrag = isPointerDragging;
          try {
            if (track.hasPointerCapture?.(event.pointerId)) track.releasePointerCapture(event.pointerId);
          } catch (error) {
            // The browser may already have released capture for a cancelled pointer.
          }
          clearDragState();

          if (!completedDrag) return;
          event.preventDefault();
          if (event.type === 'pointerup') {
            suppressDraggedClick = true;
            window.clearTimeout(suppressClickTimer);
            suppressClickTimer = window.setTimeout(() => { suppressDraggedClick = false; }, 0);
          }
          snapToNearestCard();
        };

        const handleDraggedClick = (event) => {
          if (!suppressDraggedClick) return;
          suppressDraggedClick = false;
          window.clearTimeout(suppressClickTimer);
          event.preventDefault();
          event.stopPropagation();
        };

        const handleNativeDragStart = (event) => {
          if (dragPointerId !== undefined) event.preventDefault();
        };

        const reset = () => {
          setScrollPosition(0, false);
          queueUpdate();
        };

        addListener(previousButton, 'click', () => moveByOneCard(-1));
        addListener(nextButton, 'click', () => moveByOneCard(1));
        addListener(track, 'scroll', queueUpdate, { passive: true });
        addListener(track, 'keydown', handleTrackKeydown);
        addListener(track, 'pointerdown', handlePointerDown);
        addListener(track, 'pointermove', handlePointerMove);
        addListener(track, 'pointerup', finishPointerDrag);
        addListener(track, 'pointercancel', finishPointerDrag);
        addListener(track, 'click', handleDraggedClick, true);
        addListener(track, 'dragstart', handleNativeDragStart);

        if (typeof window.ResizeObserver === 'function') {
          resizeObserver = new window.ResizeObserver(queueUpdate);
          resizeObserver.observe(track);
        } else {
          addListener(window, 'resize', queueUpdate, { passive: true });
        }

        const instance = {
          reset,
          update: queueUpdate,
          destroy: () => {
            if (updateFrame !== undefined) window.cancelAnimationFrame(updateFrame);
            window.clearTimeout(suppressClickTimer);
            clearDragState();
            resizeObserver?.disconnect();
          }
        };
        carouselInstances.set(carousel, instance);
        queueUpdate();
      };

      selector.querySelectorAll('[data-plan-carousel]').forEach(initialiseCarousel);

      categoryGroups.forEach((group) => {
        const selected = group.querySelector('[data-selector-category][aria-checked="true"]')
          || group.querySelector('[data-selector-category]');
        if (selected) rememberedCategories.set(group.dataset.categoryGroup, selected.dataset.selectorCategory);
      });

      const showCategory = (family, category) => {
        const activeGroup = categoryGroups.find((group) => group.dataset.categoryGroup === family);
        if (!activeGroup) return;

        const categoryButtons = [...activeGroup.querySelectorAll('[data-selector-category]')];
        const activeButton = categoryButtons.find((button) => button.dataset.selectorCategory === category)
          || categoryButtons[0];
        if (!activeButton) return;

        const activeCategory = activeButton.dataset.selectorCategory;
        const selectionChanged = selector.dataset.selectedFamily !== family
          || selector.dataset.selectedCategory !== activeCategory;
        rememberedCategories.set(family, activeCategory);
        categoryButtons.forEach((button) => {
          const isActive = button === activeButton;
          button.setAttribute('aria-checked', String(isActive));
          button.tabIndex = isActive ? 0 : -1;
        });

        let activePanel;
        planPanels.forEach((panel) => {
          const isActive = panel.dataset.family === family && panel.dataset.category === activeCategory;
          panel.hidden = !isActive;
          if (isActive) activePanel = panel;
        });

        if (status && activePanel) status.textContent = activePanel.dataset.announcement || 'Plan results updated.';
        selector.dataset.selectedFamily = family;
        selector.dataset.selectedCategory = activeCategory;

        if (selectionChanged && activePanel) {
          activePanel.querySelectorAll('[data-plan-carousel]').forEach((carousel) => {
            carouselInstances.get(carousel)?.reset();
          });
        }
      };

      const showFamily = (family) => {
        const activeFamilyButton = familyButtons.find((button) => button.dataset.selectorFamily === family)
          || familyButtons[0];
        if (!activeFamilyButton) return;

        const activeFamily = activeFamilyButton.dataset.selectorFamily;
        familyButtons.forEach((button) => {
          const isActive = button === activeFamilyButton;
          button.setAttribute('aria-checked', String(isActive));
          button.tabIndex = isActive ? 0 : -1;
        });
        categoryGroups.forEach((group) => {
          group.hidden = group.dataset.categoryGroup !== activeFamily;
        });

        const activeGroup = categoryGroups.find((group) => group.dataset.categoryGroup === activeFamily);
        if (categoryHeading && activeGroup?.dataset.categoryQuestion) {
          categoryHeading.textContent = activeGroup.dataset.categoryQuestion;
        }
        const remembered = rememberedCategories.get(activeFamily);
        const fallback = activeGroup?.querySelector('[data-selector-category]')?.dataset.selectorCategory;
        showCategory(activeFamily, remembered || fallback);
      };

      const handleSelectorClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const familyButton = target.closest('[data-selector-family]');
        if (familyButton && selector.contains(familyButton)) {
          showFamily(familyButton.dataset.selectorFamily);
          return;
        }

        const categoryButton = target.closest('[data-selector-category]');
        if (!categoryButton || !selector.contains(categoryButton)) return;
        const group = categoryButton.closest('[data-category-group]');
        if (!group || group.hidden) return;
        showCategory(group.dataset.categoryGroup, categoryButton.dataset.selectorCategory);
      };

      const handleSelectorKeydown = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const radio = target.closest('[role="radio"]');
        const group = radio?.closest('[role="radiogroup"]');
        if (!radio || !group || !selector.contains(group)) return;

        const radios = [...group.querySelectorAll('[role="radio"]')]
          .filter((button) => !button.disabled && !button.hidden);
        const currentIndex = radios.indexOf(radio);
        if (currentIndex < 0) return;

        let nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % radios.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + radios.length) % radios.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = radios.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        radios[nextIndex].focus();
        radios[nextIndex].click();
      };

      addListener(selector, 'click', handleSelectorClick);
      addListener(selector, 'keydown', handleSelectorKeydown);

      serviceSelectorInstances.set(selector, {
        destroy: () => {
          cleanupCallbacks.splice(0).forEach((cleanup) => cleanup());
          carouselInstances.forEach((instance) => instance.destroy());
          carouselInstances.clear();
          delete selector.dataset.selectorReady;
          serviceSelectorInstances.delete(selector);
        }
      });

      const selectedFamily = familyButtons.find((button) => button.getAttribute('aria-checked') === 'true')
        ?.dataset.selectorFamily;
      showFamily(selectedFamily || selector.dataset.defaultFamily || familyButtons[0]?.dataset.selectorFamily);
    });
  };

  const destroyServiceSelectors = (scope) => {
    getServiceSelectors(scope).forEach((selector) => serviceSelectorInstances.get(selector)?.destroy());
  };

  initialiseServiceSelectors();
  document.addEventListener('shopify:section:load', (event) => initialiseServiceSelectors(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyServiceSelectors(event.target));
})();
